import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthenticationManager} from './authentication-manager';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private router: Router,
                private authenticationManager: AuthenticationManager) {}

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const authToken = localStorage.getItem('$au');


        if (authToken) {
            return true; // Allow navigation if $au exists
        }

        // Redirect to login if $au is missing
        return this.router.createUrlTree(['/login']);
    }
}